<template>
  <div class="SiteFooter">

    <container>

      <div class="SiteFooter-content t-antialiased">

        <p class="t-caps-md c-grey-xlt2">Contact Benj&thinsp;+&thinsp;Sara</p>

        <p class="t-text-sm c-grey-lt">
          <a :href="`mailto:${global.site.email.value}`">{{ global.site.email.label }}</a>&nbsp;&nbsp;&nbsp;
          <!--<a :href="`tel:${global.site.phone.value}`" class="SiteFooter-phone">{{ global.site.phone.label }}</a>--->
        </p>


        <break size="0.75" />

        <p class="t-caps-md c-grey-xlt2">Follow us</p>

        <ul class="SiteFooter-social t-text-sm c-grey-lt">
          <!--<li><a :href="`https://confirmsubscription.com/h/y/768562AF4B29D61D`">Newsletter
          </a></li>-->
          <li v-for="item in global.site.social">
            <a :href="item.link">
              {{ item.title }}
              <!-- <icon :name="item.icon" width="24px" height="24px" /> -->
            </a>
          </li>
        </ul>



        <!-- Original <newsletter-form /> -->

      </div>
<break size="0.5" />
      <p class="SiteFooter-finePrint t-caps-sm c-grey-md">
        <span>Code by Darin Reid.</span>   <span>Our <a href="/privacy-policy">Privacy Policy</a>.</span>  <span>Copyright &copy; {{ year }}.</span>
      </p>

    </container>

  </div>
</template>

<script>
export default {
  computed: {
    year () { return new Date().getFullYear() }
  }
}
</script>

<style>
@import 'properties';

.SiteFooter {
  padding: calc(var(--unit) * 3.5) 0 var(--unit);
  background-color: var(--c-grey-dk);
}

.theme-dk .SiteFooter {
  background-color: var(--c-black) !important;
}

.SiteFooter a {
  color: var(--c-grey-lt);
}

.SiteFooter a:hover {
  color: var(--c-blue);
}


.SiteFooter-phone {
  letter-spacing: 0.05em;
}

.SiteFooter-social {
  display: flex;
  flex-wrap: wrap;
  /*margin-bottom: var(--unit-075);*/
}

.SiteFooter-social > * {
  margin-right: var(--unit-05);
}

.SiteFooter-social svg {
  fill: var(--c-grey-lt) !important;
}

.SiteFooter-social a:hover svg {
  fill: var(--c-blue) !important;
}

.SiteFooter-finePrint {
  margin-top: var(--unit-05);
  line-height: 15px;
  letter-spacing: 0em;
  text-transform: none;
  font-size: 11px;
  color: var(--c-grey-md);
}

.SiteFooter-finePrint span {
  display: inline-block;
}

.SiteFooter .TextInput-input,
.SiteFooter .TextInput-submit {
  background-color: var(--c-grey-dk-alt) !important;
  color: var(--c-grey-lt);
}

.theme-dk .SiteFooter .TextInput-input,
.theme-dk .SiteFooter .TextInput-submit {
  background-color: var(--c-grey-dk) !important;
}
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?5f4dfe9a